import { Link } from 'react-router-dom';
import EventCard from '../../../components/EventCard';
import { LoadingState, ErrorState } from '../../../components';
import './RecentEventsGrid.css';

function RecentEventsGrid({ events = [], loading = false, error = null }) {
  if (loading) {
    return (
      <div className="recent-events-grid">
        <h2>Eventi Recenti</h2>
        <LoadingState message="Caricamento eventi..." className="compact" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="recent-events-grid">
        <h2>Eventi Recenti</h2>
        <ErrorState message={error} className="compact" />
      </div>
    );
  }

  // Events are already sorted and limited to 6 by the hook
  if (events.length === 0) return null;

  return (
    <div className="recent-events-grid">
      <h2>Eventi Recenti</h2>
      <div className="events-grid-container">
        {events.map(event => (
          <EventCard
            key={event.id}
            id={event.id}
            title={event.title}
            date={event.date}
            time={event.time}
            location={event.location}
            description={event.description}
            imageUrl={event.photo_link}
            endDate={event.date_end}
          />
        ))}
      </div>
      <Link to="/events" className="view-all-link">
        Vedi tutti gli eventi →
      </Link>
    </div>
  );
}

export default RecentEventsGrid;
